module.exports = __webpack_public_path__ + "static/img/remarks.254f4ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme2/remarks.png
// module id = paXB
// module chunks = 167